import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language resources
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';

// Get saved language from localStorage or default to 'pt'
const savedLanguage = localStorage.getItem('language') || 'pt';

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        translation: pt
      },
      en: {
        translation: en
      },
      es: {
        translation: es
      }
    },
    lng: savedLanguage, // Use saved language
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false, // React already escapes by default
    }
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
